import {
  PractitionerTaskSearch,
  TaskGetAllResponse,
  TaskUpdateOverdue,
  TaskUpdateStatus,
  TaskStatus,
} from '@quromedical/models';
import { LinkTo } from 'navigation';

export type GetTasks = (body: PractitionerTaskSearch) => Promise<TaskGetAllResponse>;
export type UpdateTask = (id: string, note: string, status?: TaskStatus, dueDate?: Date) => void;
export type UpdateStatus = (body: TaskUpdateStatus) => Promise<void>;
export type UpdateOverdue = (body: TaskUpdateOverdue) => Promise<void>;
export type Link = Exclude<LinkTo, string>;
export type NavigateToTask = (link: Link) => void;
